/** @format */

import { action, computed } from 'easy-peasy';
import { TravelInValidCodeNotSelected } from '../../utils/Utils';

const CartModel = {
	travelOut: null,
	tripInValidCode: computed((state) => (state.travelOut === null ? TravelInValidCodeNotSelected : '')),
	error: { name: '', phoneNumber: '', email: '', termsAccepted: '', lpn: '' },
	contactPerson: null,
	totalSum: 0,
	title: null,
	setTravelOut: action((state, travel) => {
		state.travelOut = travel;
	}),
	setItems: action((state, travelSearch) => {
		state.items = travelSearch.items
			.filter((x) => x.countItems > 0)
			.map((x) => {
				return { count: x.countItems, name: x.article.name, sort: x.article.sort };
			});
	}),
	setTitle: action((state, travelSearch) => {
		state.title = travelSearch.fromStop.name + ' - ' + travelSearch.toStop.name;
	}),
	setContactPerson: action((state, cont) => {
		const subset = (({ Name, PhoneNumber, SmsAccepted, IsSmsSupported, Email, TermsAccepted, LPN, CarLength }) => ({
			name: Name.trim(),
			phoneNumber: PhoneNumber,
			smsAccepted: SmsAccepted && IsSmsSupported,
			email: Email.trim(),
			lpn: LPN.trim(),
			carLength: CarLength.trim().replace(/,/g, '.'),
			termsAccepted: TermsAccepted,
		}))(cont);
		state.contactPerson = subset;
	}),
	reset: action((state) => {
		state.travelOut = null;
		state.error = { name: '', phoneNumber: '', email: '', termsAccepted: '', lpn: '', carLength: '' };
		state.contactPerson = null;
		state.title = null;
		state.items = [];
	}),
};

export default CartModel;
